/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export enum ConsumableCategory {
  ABLATION_DEVICE = 'Ablation Device',

  CATHETER = 'Catheter',

  DISINFECTANT = 'Disinfectant',

  DISPOSABLE_HYPODERMIC_NEEDLE = 'Disposable Hypodermic Needle',

  DISPOSABLE_HYPODERMIC_SYRINGE = 'Disposable Hypodermic Syringe',

  DISPOSABLE_PERFUSION_SET = 'Disposable Perfusion Set',

  IV_CANNULAE = 'IV Cannulae',

  SCALP_VEIN_SET = 'Scalp Vein Set',

  SURGICAL_DRESSING = 'Surgical Dressing',

  CONTRACEPTION = 'Contraception',

  GLOVES = 'Medical Gloves',
}
